import { Col, Row } from "antd";
import { withTranslation } from "react-i18next";

import { Large } from "../Footer/styles";
import { useState } from "react";
import { ModelComponentProps } from "../types";
import { Container, InfoSection } from "./styles";
import { Content, H6White, IconWrapper } from "../styles";
import { PlayCircleOutlined, UserOutlined, SafetyOutlined, MessageOutlined } from '@ant-design/icons';
import Modal from "../../common/Modal";
import { ModalButton } from "../../common/Modal/styles";

const PrivacyPolicyModal = ({ t }: ModelComponentProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Large onClick={() => setIsModalOpen(true)}>{t("PrivacyPolicy")}</Large>
      <Modal
        title={<H6White>{t('PrivacyPolicy')}</H6White>}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <ModalButton key="back" onClick={() => setIsModalOpen(false)}>
            {t("Close")}
          </ModalButton>
        ]}
        width="min(900px, 90vw)"
      >
        <Row>
          <Col xs={24}>
            <Container>
              <InfoSection>
                <IconWrapper>
                  <UserOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('WhatHiddenTenthsMayCollect')}</Content>
              </InfoSection>
              <InfoSection>
                <IconWrapper>
                  <MessageOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('WhatTheInformationIsUsedFor')}</Content>
              </InfoSection>
              <InfoSection>
                <IconWrapper>
                  <PlayCircleOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('SubmittedLapsMayBePublic')}</Content>
              </InfoSection>
              <InfoSection>
                <IconWrapper>
                  <SafetyOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('InformationIsNotSold')}</Content>
              </InfoSection>
            </Container>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default withTranslation()(PrivacyPolicyModal);
